module.exports = __webpack_public_path__ + "h5/img/logo2.84dd9e35.png";